import { DELTA_UPDATE } from '@CS/utils/Number';
import { forwardRef, useState, useEffect } from 'react';
import CloseButton from '@CS/assets/close.svg?component';
import type { JSX, ForwardedRef, CSSProperties } from 'react';
import { PopupOverlay, PopupContainer, FADE_DURATION } from './Popup.styles';

type Child = JSX.Element | string | null;
type Children<Child> = Child | Child[];

export type PopupProps = {
  customStyle?: CSSProperties;
  children?: Children<Child>;
  onBeforeClose?: () => void;

  opacity?: number | string;
  width?: number | string;

  onClose?: () => void;
  fullScreen?: boolean;
  background?: string;

  hideClose?: boolean;
  overlay?: boolean;
  close?: boolean;
};

export const Popup = forwardRef(
  (
    {
      onBeforeClose = () => void 0,
      onClose = () => void 0,
      background = 'white',

      fullScreen = false,
      hideClose = false,

      overlay = true,
      opacity = 0.5,
      close = false,

      customStyle,
      width = 80,
      children
    }: PopupProps,
    ref: ForwardedRef<HTMLDialogElement>
  ) => {
    const [visible, setVisible] = useState(close);

    const onPopupClose = () => {
      setTimeout(onClose, FADE_DURATION);
      setVisible(false);
      onBeforeClose();
    };

    useEffect(() => {
      close && onPopupClose();
    }, [close]);

    useEffect(() => {
      setTimeout(() => setVisible(true), DELTA_UPDATE);
    }, []);

    return (
      <PopupOverlay $visible={visible} $overlay={overlay} opacity={opacity}>
        <PopupContainer
          $fullScreen={fullScreen}
          $background={background}
          style={customStyle}
          width={width}
          ref={ref}
        >
          {!hideClose && <CloseButton onClick={onPopupClose} />}
          {children}
        </PopupContainer>
      </PopupOverlay>
    );
  }
);
